<div class="loader-screen" *ngIf="loading">
	<div id="loading">
	    <div class="fol">
	        <div class="cir" id="c1"></div>
	        <div class="cir" id="c2"></div>
	        <div class="cir" id="c3"></div>
	        <div class="cir" id="c4"></div>
	    </div>
	</div>
</div>